export default class Equipe {
  constructor() {
    // Equipe
    this.formLogIn = document.querySelector('aside.popin');

    // this.searchSpecialites();
    this.searchLetters();
    this.displayLogin();
    this.closePopin();
  }

  searchSpecialites() {
    const form = document.querySelectorAll('section.content .header .search-wrapper form')[1];
    if (form) {
      form.querySelector('select').addEventListener('change', () => {
        // const getValue = form.querySelector('select#category').value;
        // const getLabel = form.querySelector(`option[value="${getValue}"]`).innerText;
        // form.querySelector('input[name="search-type"]').value = getLabel;
        form.submit();
      });
    }
  }

  searchLetters() {
    const form = document.querySelector('section.content .letters form');
    if (form) {
      form.querySelectorAll('input[name="s"]').forEach((input) => {
        input.addEventListener('change', () => {
          form.submit();
        })
      });
    }
  }

  displayLogin() {
    const unlockBtns = document.querySelectorAll('.locked');
    if (unlockBtns.length > 0) {
      unlockBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          if (this.formLogIn) {
            this.formLogIn.classList.add('open');
          }
        });
      });
    }
  }

  closePopin() {
    if (this.formLogIn) {
      this.formLogIn.querySelector('.overlay').addEventListener('click', () => {
        this.formLogIn.classList.remove('open');
      });
    }
  }
}